<template>
    <!--设置-->
    <div :class="phoneClass || 'setting-wrapper'">
        <content-header></content-header>
        <div class="setting-content" v-if="isShowInfo">
            <!-- 基本资料 -->
            <div class="floor-title">
                <div class="title">{{$t('setting.basic_data')}}</div>
                <el-button class="my-button" @click="isShowInfo = false">
                    <img src="../../assets/img/btn/icon-edit.png" class="icon">
                    <div class="text">{{$t('setting.revision_information')}}</div>
                </el-button>
            </div>
            <div class="info-display">
                <div class="info-floor">
                    <div class="key">{{$t('setting.name')}}</div>
                    <div class="value">{{data.username}}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.phone')}}</div>
                    <div class="value">{{data.phone}}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.postcode')}}</div>
                    <div class="value">{{data.postal_code}}</div>
                </div>
                <!--<div class="info-floor">-->
                    <!--<div class="key">{{$t('setting.site')}}</div>-->
                    <!--<div class="value">{{data.country}}</div>-->
                <!--</div>-->
                <div class="info-floor">
                    <div class="key">{{$t('setting.detailed_address')}}</div>
                    <div class="value">{{data.province}}{{data.city}}{{data.county}}{{data.address}}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.company')}}</div>
                    <div class="value">{{data.company}}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.profession')}}</div>
                    <div class="value">{{data.industry}}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.email')}}</div>
                    <div class="value">{{data.email}}</div>
                </div>
                <div class="info-floor" v-if="userData.role ===2 ? false : true">
                    <div class="key">{{$t('setting.email_rate')}}</div>
                    <div class="value">{{$t('selectData.setting.email.rate'+data.email_rate)}}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.microsoft_authenticator')}}</div>
                    <div class="value">{{data.is_mfa_enable === 1 ? $t('setting.open') : $t('setting.close')}}</div>
                </div>
                <div class="info-floor" v-if="userData.role == 1 || userData.role == 2 ? false : true" >
                    <div class="key">{{$t('setting.dealer')}}</div>
                    <div class="value"><div v-if="data.agent_detail">{{data.agent_detail.name}}</div></div>
                </div>
                <div class="info-floor" >
                    <div class="key">{{$t('setting.loginKey')}}</div>
                    <div class="value" v-if="data.is_auto_login_key_enable === 1">
                        <template v-if="user.login_key">
                            {{ `${origin}/#/redirect?key=${user.login_key}`}}
                        </template>
                        <el-button @click="generateLoginKey">
                            {{ user.login_key ? $t('setting.reset') : $t('setting.generate') }}
                        </el-button>
                    </div>
                    <div class="value" v-else>
                        <span class="tips" style="color:#7A8799">{{$t('setting.no_permission_available')}}</span>
                    </div>
                </div>
            </div>
            <!-- API 设置 -->
            <div class="floor-title">
                <div class="title">{{$t('setting.appTile')}}</div>
            </div>
            <div class="info-display" v-if="userData.is_open_api_enable === 1 || userData.role == 1 || userData.role == 2">
                <div class="info-floor">
                    <div class="key">{{$t('setting.app')}}</div>
                    <div class="value">
                        <el-switch
                            :active-value="Cores.Const.FLAG_APP_YES"
                            :inactive-value="Cores.Const.FLAG_APP_NO"
                            v-model="flagApp"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="appOpenOrEnd()"
                        >
                        </el-switch>
                    </div>
                </div>
                <template v-if="flagApp ===  Cores.Const.FLAG_APP_YES">
                    <div class="info-floor" >
                        <div class="key">{{$t('setting.appId')}}</div>
                        <div class="value">
                            {{appData.appId}}
                        </div>
                    </div>
                    <div class="info-floor" >
                        <div class="key">{{$t('setting.appSecret')}}</div>
                        <div class="value">
                            {{appData.appSecret}}
                        <el-button @click="resetAppSecret">{{$t('setting.reset')}}</el-button>
                        </div>
                    </div>
                    <div class="info-floor" >
                        <div class="key">{{$t('setting.alarmUrl')}}</div>
                        <div class="value1" v-show="!alarmUrlShow">
                            {{appData.alarmUrl}}
                            <div class="font-color-button" @click="updateUrl('alarmUrl')" >{{$t('setting.update')}}</div>
                        </div>
                        <div v-show="alarmUrlShow">
                            <div class="value">
                                <el-input class="width-400px" v-model="alarmUrlInput" />
                            </div>
                            <div class="value">
                                <el-button @click="saveUrl('alarmUrl', alarmUrlInput)">{{$t('setting.save')}}</el-button>
                                <el-button @click="cancelUrl('alarmUrl')">{{$t('setting.cancel')}}</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="info-floor" >
                        <div class="key">{{$t('setting.dataReportUrl')}}</div>
                        <div class="value1" v-show="!dataReportUrlShow">
                            {{appData.dataReportUrl}}
                            <div class="font-color-button" @click="updateUrl('dataReportUrl')" >{{$t('setting.update')}}</div>
                        </div>
                        <div class="value"></div>
                        <div v-show="dataReportUrlShow">
                            <div class="value">
                                <el-input class="width-400px" v-model="dataReportUrlInput" />
                            </div>
                            <div class="value">
                                <el-button @click="saveUrl('dataReportUrl', dataReportUrlInput)">{{$t('setting.save')}}</el-button>
                                <el-button @click="cancelUrl('dataReportUrl')">{{$t('setting.cancel')}}</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="info-floor" >
                        <div class="key">{{$t('setting.deviceAddUrl')}}</div>
                        <div class="value1" v-show="!deviceAddUrlShow">
                            {{appData.deviceAddUrl}}
                            <div class="font-color-button" @click="updateUrl('deviceAddUrl')" >{{$t('setting.update')}}</div>
                        </div>
                        <div class="value"></div>
                        <div v-show="deviceAddUrlShow">
                            <div class="value">
                                <el-input class="width-400px" v-model="deviceAddUrlInput" />
                            </div>
                            <div class="value">
                                <el-button @click="saveUrl('deviceAddUrl', deviceAddUrlInput)">{{$t('setting.save')}}</el-button>
                                <el-button @click="cancelUrl('deviceAddUrl')">{{$t('setting.cancel')}}</el-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="info-display" v-else>
                <div class="info-floor">
                    <!-- <div class="key">{{ $t('setting.dealer') }}</div> -->
                    <div class="tips" style="color:#7A8799">{{$t('setting.no_permission_available')}}</div>
                </div>
            </div>
            <!-- 关于 -->
            <div class="floor-title">
                <div class="title">{{$t('setting.appAbout')}}</div>
            </div>
            <div class="info-display">
                <div class="info-floor">
                    <div class="key">{{$t('setting.webVersion')}}</div>
                    <div class="value">{{ webVersion }}</div>
                </div>
                <div class="info-floor">
                    <div class="key">{{$t('setting.backendVersion')}}</div>
                    <div class="value">{{ backendVersion }}</div>
                </div>
            </div>
        </div>
        <div class="setting-content" v-else>
            <!-- 修改资料 -->
            <div class="floor-title">
                <div class="title">{{$t('setting.revision_information')}}</div>
            </div>
            <div class="info-edit">
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.name')}}</p>
                        <el-input v-model="editForm.username" :placeholder="$t('setting.name')"></el-input>
                    </div>

                    <div class="floor-block">
                        <p>{{$t('setting.phone')}}</p>
                        <el-input v-model="editForm.phone" :placeholder="$t('setting.phone')"></el-input>
                    </div>
                </div>
                <!-- 省市区、公司地址 -->
                <!-- <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.district')}}</p>
                        <el-cascader :options="regionData"
                            v-model="pcc"
                            style="width: 100%;"
                            :placeholder="$t('setting.p_c_c')"
                            :props="regionProps"
                            @change="regionChange">
                        </el-cascader>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.address')}}</p>
                        <el-input v-model="editForm.address" :placeholder="$t('setting.address')"></el-input>
                    </div>
                </div> -->
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.province')}}</p>
                        <el-input v-model="editForm.province" :placeholder="$t('setting.pvce_place')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.city')}}</p>
                        <el-input v-model="editForm.city" :placeholder="$t('setting.city_place')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.county')}}</p>
                        <el-input v-model="editForm.county" :placeholder="$t('setting.county_place')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.address')}}</p>
                        <el-input v-model="editForm.address" :placeholder="$t('setting.address')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.company')}}</p>
                        <el-input v-model="editForm.company" :placeholder="$t('setting.company')"></el-input>
                    </div>
                    <!--行业-->
                    <div class="floor-block">
                        <p>{{$t('setting.profession')}}</p>
                        <!--<el-input v-model="editForm.industry" :placeholder="$t('setting.profession')"></el-input>-->
                        <el-autocomplete
                            popper-class="my-autocomplete"
                            v-model="editForm.industry"
                            :fetch-suggestions="querySearchOne"
                            :placeholder="$t('setting.profession')"
                            @select="handleSelectOne">
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"/>
                            <template slot-scope="props">
                                <div class="name">{{ props.item.value }}</div>
                                <div class="addr">{{ props.item.address }}</div>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('setting.email')}}</p>
                        <el-input v-model="editForm.email" disabled :placeholder="$t('setting.email')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('setting.postcode')}}</p>
                        <el-input v-model="editForm.postal_code" :placeholder="$t('setting.postcode')"></el-input>
                    </div>
                </div>
                <!--邮件通知频率-->
                <div class="info-floor" >
                    <div class="floor-block" v-if="userData.role === 2 ? false : true">
                        <p>{{$t('setting.email_rate')}}</p>
                        <el-select v-model="editForm.email_rate" :placeholder="$t('setting.email_rate')" style="width:100%;" >
                            <el-option
                                    v-for="item in emailRateList"
                                    :key="item.index"
                                    :label="$t('selectData.setting.email.rate'+item.value)"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="info-floor" v-if="userData.role == 1 ||userData.role == 2 ? false : true">
                    <div class="floor-block">
                        <p>{{$t('setting.dealer')}}</p>
                        <el-input v-model="editForm.agent_detail.name" disabled placeholder="无服务商"></el-input>
                        <el-button class="button" type="text" @click="dialogFormVisible = true" v-if="userData.role == 100">{{$t('setting.apply')}}</el-button>
                        <el-dialog :title="$t('setting.remind')" :visible.sync="dialogFormVisible">
                            <el-form >
                                <div class="sect">{{$t('setting.send_message')}}</div>
                                <!--<el-form-item label="" :label-width="formLabelWidth">-->
                                    <!--<el-select v-model="editForm.agent" placeholder="请选择活动区域" :value="'1'">-->
                                        <!--<el-option-->
                                                <!--v-for="item in agentList"-->
                                                <!--:key="item.id"-->
                                                <!--:label="item.name"-->
                                                <!--:value="item.id">-->
                                        <!--</el-option>-->
                                        <!--&lt;!&ndash;<el-option label="区域一" value="shanghai"></el-option>&ndash;&gt;-->
                                    <!--</el-select>-->
                                <!--</el-form-item>-->
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="dialogFormVisible = false">{{$t('message.cancel')}}</el-button>
                                <el-button type="primary" @click="agentTrue">{{$t('setting.send')}}</el-button>
                            </div>
                        </el-dialog>
                        <!--<el-select v-model="editForm.agent" :placeholder="$t('setting.dealer')" style="width:100%;">-->
                            <!--<el-option-->
                            <!--v-for="item in agentList"-->
                            <!--:key="item.id"-->
                            <!--:label="item.name"-->
                            <!--:value="item.id"-->
                            <!--&gt;-->
                            <!--</el-option>-->
                        <!--</el-select>-->
                    </div>

                </div>
                <div class="operation">
                    <el-button type="primary" @click="updateInfo">
                        {{$t('message.preserved')}}
                    </el-button>
                    <el-button  @click="closeBt">
                        {{$t('message.cancel')}}
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Core from 'core/core'
import contentHeader from '../../components/content-header'
import region from "core/region"
import {refresh} from "core/winSize"
import axios from 'axios';
export default {
    data() {
        return {
            webVersion: Core.Const.NET.APP_VER,
            backendVersion: '-',
            user: Core.Data.getUser(),
            phoneClass: '',
            agentList: [],
            userData: '',
            data: '',
            isShowInfo: true,
            regionData: [],
            pcc: [],
            Cores: Core,
            editForm: {
                name: '',
                phone: '',
                company: '',
                postcode: '',
                profession: '',
                site: '',
                factory: '',
                email: '',
                emailFre: '',
                email_rate: '',
                is_mfa_enable: 0,
                postal_code: '',
                agent: '',
                dealer: '',
                agent_detail : {
                    name: ''
                }
            },
            flagApp: '',
            appData: {
                id: '',
                appId: '',
                appSecret: '',
                alarmUrl: '',
                dataReportUrl: '',
                deviceAddUrl: '',

            },
            alarmUrlShow: false,
            alarmUrlInput: '',
            dataReportUrlShow: false,
            dataReportUrlInput: '',
            deviceAddUrlShow: false,
            deviceAddUrlInput: '',


            emailRateList: Core.Const.emailRateList,
            regionProps: {
                value: 'name',
                label: 'name'
            },
            dialogTableVisible: false,
            dialogFormVisible: false,
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            formLabelWidth: '50px',
            industry: '',
            industrys: [],
            checkEmailShow: false,
            origin: '',
        };
    },
    components: {
        contentHeader
    },
    created() {
	    refresh(this,'phoneClass-setting-wrapper');
	    window.onresize = function(){
		    setTimeout(function(){
			    refresh(this,'phoneClass-setting-wrapper');
		    },10)
	    };
    },
    watch: {
        pcc: function(newVal, oldVal) {
            console.log('pcc newVal:', newVal)
        }
    },
    computed: {
    },
    mounted() {
        console.log('location', window.location);
        this.origin = window.location.origin
        this.initRegion()
        this.userData=Core.Data.getUser()
        this.detailList()
        this.initIndustry()
        this.providersListAll()
        this.getApp()
        this.getVersion()
    },
    methods: {
	    initRegion() {
		    axios
		    .get('/ext/region-code.json')
		    .then(response => {
			    this.regionData = response.data.zh
		    })
	    },
        detailList(){
            Core.Api.User.detail(this.userData.id).then((res)=>{
                console.log(res,'lis');
                this.editForm = res
                this.user = res
                this.userData = res
                Core.Data.setUser(res)
                this.pcc = [res.province,res.city ? res.city.trim() : '',res.county]
                if(!res.agent_detail){
                    this.editForm.agent_detail = {
                        name: ''
                    }
                }
                this.data = res
                // this.initSite(res)
            })

        },
        initSite(res) {
	        this.regionData.forEach(itemProvince => {
		        if (itemProvince.code === res.province) {
			        this.data.province = itemProvince.name
			        itemProvince.children.forEach(itemCity => {
				        if (itemCity.code === res.city) {
					        this.data.city = itemCity.name
					        itemCity.children.forEach(itemCounty => {
						        if (itemCounty.code === res.county) {
							        this.data.county = itemCounty.name
						        }
					        })
				        }
			        })
		        }
	        })
        },
        providersListAll(){
            Core.Api.Agent.listAll().then((res)=>{
                // console.log(res,'listAll');
                this.agentList = res.agent_list
            })
        },
        regionChange(e) {
            let [province, city, county] = this.pcc
            this.editForm.province = province
            this.editForm.city = city.trim();
            this.editForm.county = county
        },
        goDeviceEdit(row) {
            let id = 0;
            if(row.id) {
                id = row.id
            }
            this.$router.push(`/device/add${id?'?device_id='+id : ''}`)
        },
        updateInfo() {
            let info = this.editForm
            this.checkEmail()
            if (!this.checkEmailShow){
	            // if(info.phone.length !== 8 && info.phone.length>0){
		        //     if (info.phone.length !== 12) {
			    //         if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(info.phone))){
				//             this.$message.error('手机号码有误，请重填');
				//             return false;
			    //         }
		        //     }
	            // }
	            Core.Api.User.updateUserInfo(
                    info.id , info.username , info.phone , info.postal_code , info.province , info.city ,
                    info.county , info.address , info.company , info.industry, info.email , info.email_rate
                ).then((res)=>{
                    this.$message.success('修改设置成功');
                    this.isShowInfo = true
                    this.detailList()
                })
            }
        },
        checkEmail(){
            if(this.editForm.email){
                let email = this.editForm.email;
	            let emailReg = Core.Const.EMAIL_REG
	            if( emailReg.test(email) ){
                    this.checkEmailShow = false
                } else {
                    this.checkEmailShow = true
                    this.$message.error('邮箱格式不正确');
                }
            } else {
                this.checkEmailShow = true
                this.$message.error('请输入邮箱');
            }
        },
        closeBt(){
            this.isShowInfo = true
            this.detailList()
        },
        agentTrue(){
            Core.Api.User.applyUpdateAgent().then((res)=>{
                this.$message({
                    message: '成功发送申请',
                    type: 'success'
                });
                this.dialogFormVisible = false
            })
        },

        initIndustry(){
            Core.Api.Config.getIndustryList().then(res => {
                this.editForm.industrys = res.application_list
                this.restaurantsOne = this.loadAllOne();
            })
        },
        querySearchOne(queryString, cb) {
            var restaurants = this.restaurantsOne;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        loadAllOne() {
            let arr=[]
            for (let x in this.editForm.industrys) {
                arr.push({"value":this.editForm.industrys[x].name})
            }
            console.log(arr,'arr');
            return arr
        },
        handleIconClick(ev) {
            console.log(ev);
        },
        handleSelectOne() {

        },
        appOpenOrEnd() {
            Core.Api.App.openOrEnd(this.appData.id, this.flagApp, 0).then(res =>{
                this.getApp()
            })
        },
        // 从后端配置文件读取后端版本号
        getVersion() {
            Core.Api.Config.getVersion().then(res => {
                this.backendVersion = res.backend_version || '-'
            })
        },
        getApp() {
            Core.Api.App.detail().then(res =>{
                this.appData = res.detail
                if (this.appData.id > 0){
                    this.flagApp =  Core.Const.FLAG_APP_YES;
                } else {
                    this.flagApp = Core.Const.FLAG_APP_NO;
                }
            })
        },
        generateLoginKey() {
            Core.Api.User.generateLoginKey().then(res =>{
                this.user.login_key = res.key
                Core.Data.setUser(this.user)
                this.$message.success("reset success")
            }).catch(e => {
                this.$message.error("reset error")
            })
        },
        resetAppSecret() {
            Core.Api.App.resetAppSecret(this.appData.id).then(res =>{
                this.getApp()
            })
        },
        updateUrl(url) {
            switch (url) {
                case 'alarmUrl':
                    this.alarmUrlShow = true;
                    this.alarmUrlInput = this.appData.alarmUrl
                    break;
                case 'dataReportUrl':
                    this.dataReportUrlShow = true;
                    this.dataReportUrlInput = this.appData.dataReportUrl
                    break;
                case 'deviceAddUrl':
                    this.deviceAddUrlShow = true;
                    this.deviceAddUrlInput = this.appData.deviceAddUrl
                    break;
            }
        },
        saveUrl(url, callbackUrl) {
            Core.Api.App.updateUrl(this.appData.id,callbackUrl, url ).then(res =>{
                this.getApp()
            })
            switch (url) {
                case 'alarmUrl':
                    this.alarmUrlShow = false;
                    this.alarmUrlInput = ""
                    break;
                case 'dataReportUrl':
                    this.dataReportUrlShow = false;
                    this.dataReportUrlInput = ""
                    break;
                case 'deviceAddUrl':
                    this.deviceAddUrlShow = false;
                    this.deviceAddUrlInput = ""
                    break;
            }
        },
        cancelUrl(url) {
            switch (url) {
                case 'alarmUrl':
                    this.alarmUrlShow = false;
                    this.alarmUrlInput = ""
                    break;
                case 'dataReportUrl':
                    this.dataReportUrlShow = false;
                    this.dataReportUrlInput = ""
                    break;
                case 'deviceAddUrl':
                    this.deviceAddUrlShow = false;
                    this.deviceAddUrlInput = ""
                    break;
            }
        }
    },
}
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.setting-wrapper {
    background-color: #F7F9FA;
    height: 100%;
    border-bottom: 1px solid transparent;
    .setting-content {
        margin: 30px 13vw;
        .floor-title {
            @include flex-sb;
            margin-top: 20px;
            margin-bottom: 20px;
            .title {
                font-weight: 500;
                font-size: 20px;
                color: #363D42;
            }
            .my-button {
                border-color: #0F58D6;
                .icon {
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                }
                .text {
                    font-size: 14px;
                    color: #0F58D6;
                    vertical-align: middle;
                    line-height: 20px;
                    margin-left: 6px;
                }
            }
        }
        .info-display {
            .info-floor {
                height: 50px;
                border-bottom: 1px dotted #EBEDF3;
                line-height: 49px;
                display: flex;
                .key {
                    width: 180px;
                    margin-right: 10px;
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;
                    color: #7A8799;
                }
                .value {
                    display: inline-block;
                    vertical-align: middle;
                }
                .value1{
                    display: flex;
                }
              //.value1{
              //  display: none;
              //  vertical-align: middle;
              //}
            }
        }
        .info-edit {
            .info-floor {
                margin-bottom: 20px;
                .floor-block {
                    display: inline-block;
                    width: calc(50% - 20px);
                    p {
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #7A8799;
                    }
                    &:first-child {
                        margin-right: 1.5vw;
                    }
                }
            }
            .operation {
                margin-top: 30px;
                .el-button {
                    padding: 9px 42px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.setting-wrapper {
    .info-edit {
        .info-floor {

            .el-input {
                height: 40px;
                .el-input__inner {
                    height: 40px;
                }
            }

            .floor-block{
                position: relative;
                .el-autocomplete {
                    width: 100%;
                }
                .button {
                    position: absolute;
                    top: 33px;
                    left: 81%;
                    border: 1px #ecf0f4 solid;
                    padding: 5px;
                    background: #f7f9fa;
                }
                .el-dialog {
                    width: 40%;
                }
                .el-dialog__body {
                    margin-top: 30px;
                    margin-right: 30px;

                    .sect {
                        margin: 30px 30px 10px 50px;
                        font-size: 15px;
                        font-weight: 600;
                    }
                    .el-select {
                        width: 100%;
                    }
                }
                .el-dialog__footer {
                    padding-bottom: 30px;
                    padding-right: 30px;
                    .el-button--default {
                        position: relative;
                        left: 100px;
                        width: 90px ;
                    }
                    .el-button--primary {
                        position: relative;
                        right: 100px;
                        width: 90px ;
                    }
                }
            }
        }

        .el-input__suffix-inner {
            display: none;
        }
    }
    .font-color-button{
        color: #0A3D95;
        cursor:pointer;
      display: flex;
    }
    .width-400px{
        width: 400px;
    }

}

.phoneClass-setting-wrapper {
    background: white;
    position: relative;
    .setting-content {
        width: 85%;
        margin: 0px auto 20px;
        .floor-title {
            .title {
                font-size: 20px;
                width: 120px;
                font-weight: 500;
                margin-bottom: 15px;
                margin-top: 20px;
            }
            .my-button {
                width: 6.5rem;
                height: 39px;
                background: #0F58D6;
                border-color: #0F58D6;
                line-height: 1;
                white-space: nowrap;
                cursor: pointer;
                text-align: center;
                font-size: 12px;
                border-radius: 4px;
                font-weight: 500;
                position: absolute;
                bottom: 70px;
                left: 50%;
                transform: translateX(-50%);
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .icon{
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                }
            }
        }
        .info-display {
            padding-bottom: 140px;
            .info-floor {
                border-bottom: 1px dotted #EBEDF3;
                padding: 10px 0;
                display: flex;
                &:last-child {
                    border-bottom: none;
                }
                .key {
                    min-width: 120px;
                    max-width: 120px;
                    margin-right: 10px;
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;
                    color: #7A8799;
                }
                .value {
                    vertical-align: middle;
                }
            }
        }
        .info-edit {
            padding-bottom: 50px;
            .info-floor {
                padding: 0px 0;
                .floor-block {
                    p {
                        margin-bottom: 6px;
                    }
                    .el-autocomplete {
                        width: 99%;
                        .el-input__suffix {
                            display: none;
                        }
                    }
                    width: 99%;
                    display: inline-block;
                    margin-bottom: 15px !important;
                    .el-dialog__wrapper {
                        .el-dialog {
                            width: 70%;
                            .el-dialog__body {
                                padding: 30px;
                            }
                            .el-dialog__footer {
                                padding:0 30px 30px 0;
                            }
                        }
                    }
                }
            }
            .operation {
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                .el-button {
                    padding: 9px 42px;
                    margin-left: 0;
                    margin-bottom: 15px;
                }
            }
        }

    }

}
</style>
